// test967
(967 && 0);
